
var Hammer = require('hammerjs')

var _bindButton = function () {
    $('#open-menu-button').click(function () {
        $('#open-menu-button').toggleClass('opened');
        $('body').toggleClass('mobile-menu-open');
        $('.go-up-button').fadeToggle(10);
    });
    //everything after the header should close the menu
    $('.site-header ~ *').click(function () {
        $('body').removeClass('mobile-menu-open');
    })
    //the swipe
    var mc = new Hammer.Manager($('body')[0], {});

    mc.add(new Hammer.Swipe({
        direction: Hammer.DIRECTION_RIGHT
    }))

    mc.on("swipe", function () {
        $('body').removeClass('mobile-menu-open');
    })
}

var _menuHeightHandler = function () {
    var $menu = $('.site-mobile-nav');
    $menu.height($(window).outerHeight());
}

// Prevents window from moving on touch on newer browsers.
window.addEventListener('touchmove', function (event) {
    event.preventDefault()
}, { passive: false })

$().ready(function () {
    _bindButton();
    _menuHeightHandler();

    // Allows content to move on touch.
    document.querySelector('.bodyContainer').addEventListener('touchmove', function (event) {
        event.stopPropagation()
    }, false)
})

$(window).resize(function () {
    _menuHeightHandler();
})


/* When the user scrolls down, hide the navbar. When the user scrolls up, show the navbar */
var prevScrollpos = window.pageYOffset;
window.onscroll = function () {
    var currentScrollPos = window.pageYOffset;
    if (prevScrollpos > currentScrollPos || currentScrollPos < 0) {
        setTimeout(function () {
            if (document.getElementById('site_header') != null) {
                document.getElementById('site_header').classList.remove("menu-pos");
            }
            if (document.getElementById('navigation') != null) {
                document.getElementById('navigation').classList.remove("nav-pad");
            }
        }, 350);
    } else {
        setTimeout(function () {
            if (document.getElementById('site_header') != null) {
                document.getElementById("site_header").classList.add("menu-pos");
            }
            if (document.getElementById('navigation') != null) {
                document.getElementById('navigation').classList.add("nav-pad");
            }
        }, 175);
    }
    prevScrollpos = currentScrollPos;
}